import React from "react";
import styles from "./AutocompleteOptionLabel.module.css";

interface IAutocompleteOptionLabel {
  isSecondary?: boolean;
  children?: React.ReactNode;
}

const AutocompleteOptionLabel: React.FC<IAutocompleteOptionLabel> = ({
  isSecondary = false,
  children,
}) => (
  <div className={`${styles.label} ${isSecondary ? styles.secondary : ""}`}>
    {children}
  </div>
);

export default AutocompleteOptionLabel;
